import React, { useContext } from 'react';
import { Sidebar, Menu, MenuItem } from 'react-pro-sidebar';
import { NavLink, useNavigate } from 'react-router-dom';
import '../../styles/ProSidebarBase.css';
import { AuthContext } from '../../context/AuthContext';
import { logoutRequest } from '../../services/api';

export type NavItem = { label: string; to: string };
export interface BaseProps {
  items: NavItem[];
}

const ProSidebarBase = ({ items }: BaseProps) => {
  const authContext = useContext(AuthContext);
  const logout = async () => {
    try {
      await logoutRequest();
      authContext?.logout();
    } catch (error) {
      // apiエラー時もアクセストークン等を削除してログアウト処理を行う
      authContext?.logout();
    }
  };
  return (
    <Sidebar
      className="app-sidebar"
      collapsed={false}
      width="var(--sidebar-width)"
    >
      <div className="sidebar-header">業務基幹システム</div>

      <div className="sidebar-body">
        <Menu className="sidebar-menu">
          {items.map((it) => (
            <MenuItem key={it.to} component={<NavLink to={it.to} />}>
              {it.label}
            </MenuItem>
          ))}
        </Menu>

        <div className="sidebar-logout">
          <button onClick={logout}>ログアウト</button>
        </div>
      </div>
    </Sidebar>
  );
};

export default ProSidebarBase;
